import { Label as LabelPrimitive } from "radix-ui";
import type * as React from "react";

import { cn } from "@/lib/utils";

type LabelProps = React.ComponentProps<typeof LabelPrimitive.Root> & {
  for?: string;
};

function Label({ className, htmlFor, for: legacyFor, ...props }: LabelProps) {
  const controlId = htmlFor ?? legacyFor;

  return (
    <LabelPrimitive.Root
      className={cn(
        "flex min-h-[44px] cursor-pointer select-none items-center gap-2 py-2 font-medium text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50 group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50",
        className,
      )}
      data-slot="label"
      htmlFor={controlId}
      {...props}
    />
  );
}

export { Label };
